// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__1bF0x","addWidgetButton":"Header_addWidgetButton__3gWim","dashboardTabs":"Header_dashboardTabs__DYs2t","active":"Header_active__1ZD3X"};